import queries from "@/queries";
import { useQuery } from "@tanstack/react-query";

const TOOL_CALLS_POLL_INTERVAL_MS = 2000;

/**
 * 표별 tool 호출 로그(req/resp). 아코디언이 펼쳐졌을 때만(`enabled`) 조회하고, 그 표가
 * 아직 RUNNING 이면 라이브로 폴링한다(완료되면 1회만 조회).
 */
export const useAutoTagToolCalls = (
  workbookId: string | undefined,
  tableId: string,
  options: { enabled: boolean; isRunning: boolean },
) =>
  useQuery({
    ...queries.workbook(workbookId ?? "")._ctx.autoTagToolCalls(tableId),
    enabled: options.enabled && !!workbookId,
    refetchInterval: options.isRunning ? TOOL_CALLS_POLL_INTERVAL_MS : false,
    gcTime: 0,
    staleTime: 0,
  });
